export default {
  getSubAccounts(state) {
    return state.subAccounts;
  },
  getSubAccountLimit(state) {
    return state.subAccountLimit;
  },
  isCreatingSubAccount(state) {
    return state.isCreatingSubAccount;
  },
  isDeletingSubAccount(state) {
    return state.isDeletingSubAccount;
  },
  isResettingPassword(state) {
    return state.isResettingPassword;
  },
  isChangingPassword(state) {
    return state.isChangingPassword;
  },
  getAccountErrors(state) {
    return state.errors;
  },
  getCreateError(state) {
    return state.errors.create;
  },
  getDeleteError(state) {
    return state.errors.delete;
  },
  getResetPasswordError(state) {
    return state.errors.resetPassword;
  },
  getChangePasswordError(state) {
    return state.errors.changePassword;
  },
  getSubAccountCount(state) {
    return state.subAccounts.length;
  },
  canCreateNewSubAccount(state) {
    return (
      state.subAccountLimit === null ||
      state.subAccounts.length < state.subAccountLimit
    );
  },
};
